'use client';
import { useEffect } from 'react';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

// Défilement adouci à la molette et au pavé tactile (Lenis). Le scroll reste natif :
// position sticky, ancres et animations liées au scroll continuent de fonctionner.
// Désactivé si l'utilisateur a demandé de réduire les animations ; le tactile garde le scroll du téléphone.
export default function SmoothScroll() {
    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const lenis = new Lenis({ autoRaf: true, anchors: true, lerp: 0.1 });
        return () => lenis.destroy();
    }, []);
    return null;
}
